import { render, staticRenderFns } from "./ItemListOpenMarketLayout.vue?vue&type=template&id=e44a2ed0&scoped=true"
import script from "./ItemListOpenMarketLayout.vue?vue&type=script&lang=js"
export * from "./ItemListOpenMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44a2ed0",
  null
  
)

export default component.exports